import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function ExecuteButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faSignature} />}
      color="success"
    />
  );
}

ExecuteButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ExecuteButton.defaultProps = {
  content: 'Провести',
  disabled: false,
};

export default ExecuteButton;
